import React, { useState } from "react";
import logo from "../../../assets/images/whiky_house/351334625_725651462902760_8372993541499955435_n.jpg";
import { AiOutlineMenu } from "react-icons/ai";
import { BsCart } from "react-icons/bs";
import { Link } from "react-router-dom";
import paths from "../../../routes/paths";
import { IoIosArrowDown } from "react-icons/io";
// import { SlideData } from "../../../template_codes/whisky_house/home_page";
const Header = ({ SlideData }) => {
  const [headerOpen, setHeaderOpen] = useState(true);
  const [serchTerm, setSearchTerm] = useState("");
  return (
    <>
      <nav className="my-5 relative flex items-center gap-3 px-4 justify-between  md:hidden">
        <Link to={paths.home}>
          <img src={logo} className="w-10 rounded-full h-auto" alt="" />
        </Link>
        <div className="dropdown  dropdown-end hover:scale:105 transition">
          <div className="bg-white p-1 rounded-full" tabIndex={0}>
            <AiOutlineMenu className="cursor-pointer   text-black " />
          </div>

          <ul
            tabIndex={0}
            className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-56 mt-5"
          >
            <>
              <li>
                <Link to={paths.home} className="uppercase text-xs ">
                  home
                </Link>
              </li>
            </>

            <li className="text-xs ">
              <a href="#lookbook">Lookbook</a>
            </li>
            <li>
              <a href="" className="uppercase text-xs text-red-700">
                SHOP
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className=" md:block hidden">
        {" "}
        <div class="navbar  px-5 z-50 pt-4">
          <div className="navbar-start gap-4">
            <div
              className="cursor-pointer"
              onClick={() => setHeaderOpen(!headerOpen)}
            >
              <AiOutlineMenu size={24} />
            </div>
            <div>
              <img src={logo} className="w-16" alt="" />
            </div>
          </div>

          <div className="flex items-center">
            <div className="flex flex-col relative">
              <div className="flex shadow-sm">
                <input
                  value={serchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  type="text"
                  className="block w-[60vw] px-4 py-2  bg-white border 
             focus:outline-none "
                  placeholder="What are you looking for ? ..."
                />
                <button className="px-4 text-white bg-[#3B7779]  ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              </div>
              {serchTerm.length != "" && (
                <div className=" w-[90%] shadow-lg absolute top-11 z-20 pb-5 bg-white ">
                  <ul>
                    {SlideData?.filter((pd) => {
                      if (serchTerm === "") {
                        return pd;
                      } else if (
                        pd.cate
                          .toLowerCase()
                          .includes(serchTerm.toLocaleLowerCase())
                      ) {
                        return pd;
                      }
                    }).map((item) => (
                      <li
                        className="flex gap-5 hover:bg-[#3B777917] p-2 bg-white"
                        key={item.id}
                      >
                        <div>
                          <img className="w-16 " src={item?.img} alt="" />
                        </div>
                        <div>
                          <p className="text-lg pr-12">{item?.cate}</p>
                          <p className="text-[#3B7779]">{item?.price}</p>
                        </div>
                      </li>
                    ))}
                    <p className="text-center text-[#3B7779]">
                      View All results
                    </p>
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div class="navbar-end">
            <div class="row">
              <div className="ms-10">
                <BsCart size={24} />
              </div>
            </div>
          </div>
        </div>
        {headerOpen && (
          <div class="flex justify-center pb-3 items-center transition-all px-5 z-50 p-0">
            <div className="flex items-center">
              <div className="flex ">
                <ul class="flex gap-4 ">
                  <li className=" p-1 text-sm cursor-pointer tracking-wider nav-link inline-block  ">
                    HOME
                  </li>
                  <li className=" p-1 text-sm cursor-pointer tracking-wider nav-link inline-block uppercase titlefont">
                    SHOP
                  </li>
                  <a
                    href="https://thewhiskyhousemm.com/contact"
                    className=" p-1 text-sm cursor-pointer tracking-wider nav-link inline-block uppercase titlefont"
                  >
                    Contact Us
                  </a>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
